module.exports = __webpack_public_path__ + "img/oxford-footer-bg-pc.71f65cc0.png";